import React from 'react';

const UiContext = React.createContext({
    sidebarVisible: false,
    setSidebarVisible: () => {},
    headerHeight: 0,
    setHeaderHeight: () => {},
    footerHeight: 0,
    setFooterHeight: () => {},
});

export default UiContext;